// extracted by mini-css-extract-plugin
export default {"root":"_13dLJ","content":"_3ojsx","loading":"_2DuIM","loader":"JHrJ5"};